import httpClient from '@/core/http/client.service';
import { getRuntimeConfig } from '@/utils/env';

/**
 * Return auth user jwt vaues
 *
 * @return {[type]} [description]
 */
export function getToken() {
  const token = localStorage.getItem('_user');

  if (!token) {
    return null;
  }

  return JSON.parse(token);
}

/**
 * [getUser description]
 *
 * @return {[type]} [description]
 */
export function getUser() {
  return httpClient.get('api/v1/user/info?_format=json');
}

/**
 * [logout description]
 *
 * @return {[type]} [description]
 */
export function logout() {
  localStorage.removeItem('_user');
}

/**
 * [resetPassword description]
 *
 * @return {[type]} [description]
 */
export function resetPassword(password) {
  return httpClient.post('api/v1/user/reset-password?_format=json', { password })
    .then((res) => {
      if (res.status === 200) {
        logout();
      }
    });
}

/**
 * [setCsrfToken description]
 *
 */
export function setCsrfToken() {
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: '',
    },
  };

  return httpClient.get('/session/token', config)
    .then((res) => {
      httpClient.defaults.headers.common['X-CSRF-Token'] = res.data;
    });
}

export const getRefreshToken = async (refreshToken) => {
  const runtimeConfig = await getRuntimeConfig();

  return new Promise((resolve, reject) => {
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };

    const bodyFormData = new FormData();

    bodyFormData.set('grant_type', 'refresh_token');
    bodyFormData.set('client_id', runtimeConfig.authClientId);
    bodyFormData.set('client_secret', runtimeConfig.authClientSecret);
    bodyFormData.set('refresh_token', refreshToken);

    httpClient.post('/oauth/token', bodyFormData, config)
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        reject(err);
      });
  });
};


/**
 * Check if user authentication is valid
 *
 * @return {Boolean} [description]
 */
export const isAuthenticated = () => {
  const token = getToken();

  if (token === null) {
    return false;
  }

  return true;
};

export default {
  setCsrfToken,
  getToken,
  isAuthenticated,
  getUser,
  logout,
  resetPassword,
  getRefreshToken,
};
